import React from 'react';
import './MembershipPage.css';

const WHO_CAN_JOIN = [
  {
    title: 'Kalite mühendisleri',
    desc: 'Kalite mühendisliği alanında çalışan, kalite yönetim sistemleri ve süreç iyileştirme konularında deneyimli profesyoneller.',
  },
  {
    title: 'Kalite yöneticileri',
    desc: 'Kurumlarda kalite yönetimi birimlerinde görev alan, kalite stratejisi ve uygulama süreçlerinden sorumlu yöneticiler.',
  },
  {
    title: 'Denetçiler',
    desc: 'İç veya dış denetim faaliyetlerinde bulunan, kalite ve yönetim sistemi denetimlerinde yetkinlik sahibi profesyoneller.',
  },
  {
    title: 'Akademisyenler',
    desc: 'Kalite yönetimi, üretim sistemleri veya ilgili alanlarda akademik çalışma yürüten öğretim üyeleri ve araştırmacılar.',
  },
];

const BENEFITS = [
  {
    title: 'Mesleki sicil kaydı',
    desc: 'Resmi mesleki kayıt ve tanınırlık; meslek mensubunun yetkinlik ve deneyiminin kayıt altına alınması.',
  },
  {
    title: 'Yetkinlik doğrulama',
    desc: 'Yetkinliklerin belgelenmesi ve ilgili taraflarca doğrulanabilir referans oluşturulması.',
  },
  {
    title: 'Teknik ağ ve iş birlikleri',
    desc: 'Sektör profesyonelleri ile iletişim, bilgi paylaşımı ve iş birliği imkânları.',
  },
  {
    title: 'Eğitim ve gelişim fırsatları',
    desc: 'Seminer, eğitim ve etkinliklere öncelikli erişim ve güncel mesleki gelişim desteği.',
  },
  {
    title: 'Referans dokümanlara erişim',
    desc: 'TKMB tarafından hazırlanan rehber ve standart dokümanlardan yararlanma imkânı.',
  },
];

const PROCESS_STEPS = [
  'Başvuru formunun doldurulması ve gerekli belgelerin iletilmesi',
  'Başvurunun TKMB tarafından değerlendirilmesi',
  'Üyelik kriterlerinin karşılanması halinde sicil kaydının oluşturulması',
  'Üyelik bilgilerinin ve yetkinlik doğrulama süreçlerinin tamamlanması',
];

const FAQ = [
  { q: 'Üyelik ücreti var mı?', a: 'Üyelik ücreti yıllık 2.000 TL\'dir. Güncel bilgi için info@tkmb.org adresinden bizimle iletişime geçebilirsiniz.' },
  { q: 'Üyelik süreci ne kadar sürer?', a: 'Başvuru ve belgelerin eksiksiz iletilmesinden sonra değerlendirme süreci başlar; süre başvuru yoğunluğuna göre değişebilir.' },
  { q: 'Yurt dışından üye olunabilir mi?', a: 'TKMB ulusal bir mesleki platformdur; yurt dışından başvuru kabulü ve koşulları hakkında detay için iletişime geçebilirsiniz.' },
];

const MembershipPage = () => {
  return (
    <div className="membership-page page-wrapper">
      <div className="page-hero">
        <div className="container">
          <h1 className="page-hero-title">Üyelik</h1>
          <p className="page-hero-subtitle">
            TKMB üyeliği ile mesleki sicil kaydı, yetkinlik doğrulama ve teknik ağ imkânlarından yararlanın.
          </p>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <section className="content-section intro-block">
            <p>
              Türkiye Kalite Mühendisleri Birliği üyeliği, kalite mühendisliği alanında çalışan profesyonellere
              mesleki tanınırlık, yetkinlik doğrulama ve sektör ağına erişim imkânı sunar. Aşağıda kimlerin üye
              olabileceği, üyelik kazanımları, başvuru süreci ve sık sorulan sorulara yer verilmektedir.
            </p>
            <p className="membership-fee-note">
              <strong>Üyelik ücreti yıllık 2.000 TL'dir.</strong>
            </p>
          </section>

          <section className="content-section">
            <h2>Kimler Üye Olabilir</h2>
            <p className="section-lead">
              Aşağıdaki profillerdeki meslek mensupları TKMB üyeliği için başvuruda bulunabilir:
            </p>
            <div className="membership-cards">
              {WHO_CAN_JOIN.map((item, index) => (
                <div key={index} className="membership-card">
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="content-section">
            <h2>Üyelik Kazanımları</h2>
            <p className="section-lead">
              Üyelerimiz aşağıdaki kazanımlardan yararlanabilir:
            </p>
            <div className="benefits-list">
              {BENEFITS.map((item, index) => (
                <div key={index} className="benefit-item">
                  <h4>{item.title}</h4>
                  <p>{item.desc}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="content-section">
            <h2>Başvuru Süreci</h2>
            <p className="section-lead">
              Üyelik başvurusu aşağıdaki adımlardan oluşur:
            </p>
            <ol className="process-steps">
              {PROCESS_STEPS.map((step, index) => (
                <li key={index}>
                  <span className="step-num">{index + 1}</span>
                  {step}
                </li>
              ))}
            </ol>
          </section>

          <section className="content-section">
            <h2>Sık Sorulan Sorular</h2>
            <dl className="faq-list">
              {FAQ.map((item, index) => (
                <div key={index} className="faq-item">
                  <dt>{item.q}</dt>
                  <dd>{item.a}</dd>
                </div>
              ))}
            </dl>
          </section>

          <p className="contact-cta">
            Üyelik başvurusu ve detaylı bilgi için <a href="mailto:info@tkmb.org">info@tkmb.org</a> adresinden bizimle iletişime geçebilirsiniz.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MembershipPage;
